import { environment } from "../../../environment";
var EIGHT_HOURS_MS = 8 * 60 * 60 * 1000;
export var QUERY_CLIENT_CONFIG = {
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            staleTime: environment.poolingInterval,
            retry: false,
            gcTime: EIGHT_HOURS_MS,
        },
    },
};
